// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"62":"kubearchive-logs","317":"issues-overview","336":"ai-chat-dock","502":"monaco","876":"tekton-logs","976":"issues-list-page"}[chunkId] || chunkId) + ".css";
};